define('uikit/mixins/sidebar.mixin',['require','exports','module','jquery','underscore','../modules/modal2','semantic/modules/sidebar'],function(require, exports, module) {
  var $         = require('jquery');
  var _         = require('underscore');
  var ModalView = require('../modules/modal2');
  require('semantic/modules/sidebar');

  var SidebarMixin = {

    defaultDomElementVisibility: false,

    injectInternalViewsSynchronously: true,

    initialize: function() {
      ModalView.registerModalView(this);
      this
        .on('before:render', function() {
          this.insertIntoDom();
          this.didSetupModule = false;
          this.setupSidebarModule();
        })
        .on('modal:show', function() {
          this.denyWasPressed = false;
          this.confirmWasPressed = false;
        })
        .on('modal:hidden', function(self, options) {
          _.defer(_.bind(function() {
            if (this.getOption('destroyOnHidden') && !_.result(options, 'resistDestroy')) {
              this.destroy();
            }
          }, this));
        })
        .on('deny', function() {
          this.denyWasPressed = true;
        })
        .on('confirm', function() {
          this.confirmWasPressed = true;
        })
        .on('confirm deny', function() {
          if (this.denyWasPressed && this.canCancelSidebarClose) {
            this.trigger('sidebar:hasUnsavedChanges');
            return
          }

          if (this.confirmWasPressed && this.canCancelSidebarClose) {
            return
          }
          
          this.visible = false;
        })

      this.on('change:visible', function() {
        if (this.visible === true && !this.isRendered) {
          this.show({ force: true });
        }
      });

      if (this.getOption('visible') === true) {
        this.show({ force: true })
      }
    },

    insertIntoDom: function() {
      if (this.$el && this.getOption('insertToBody')) {
        $(document.body).prepend(this.$el);
      }
    },

    _show: function() {
      if (!this.isRendered) { return this.render(); }

      var self = this;

      $('.pusher').on('click.sidebar', function(ev) {
        if (self.canCancelSidebarClose) {
          ev.stopPropagation();
          self.trigger('sidebar:hasUnsavedChanges');
        }
      });

      this.$el.sidebar('show');
    },

    _hide: function() {
      if (!this.isRendered) { return; }

      $('body').off('click.sidebar');

      this.$el.sidebar('hide');
    },

    setupSidebarModule: function() {
      if (this.didSetupModule) { return; }

      this.didSetupModule = true;

      var self    = this;
      // configure sidebar
      this
        .$el
        .sidebar({
          transition: this.getOption('transition'),
          dimPage: this.getOption('dimPage'),
          onShow: function() {
            var options = {};
            self._setOption('visible', true, { internalVisibilityAction: true });
            self.triggerMethod('sidebar:show', self, options);
            self.triggerMethod('modal:show', self, options);
          },
          onVisible: function() {
            var options = {};
            self.triggerMethod('sidebar:visible', self, options);
            self.triggerMethod('modal:visible', self, options);
          },
          onHide: function() {
            var options = {
              denyWasPressed: self.denyWasPressed,
              confirmWasPressed: self.confirmWasPressed
            };
            self._setOption('visible', false, { internalVisibilityAction: true });
            self.triggerMethod('sidebar:hide', self, options);
            self.triggerMethod('modal:hide', self, options);
          },
          onHidden: function() {
            var options = {
              denyWasPressed: self.denyWasPressed,
              confirmWasPressed: self.confirmWasPressed
            };
            self.triggerMethod('sidebar:hidden', self, options);
            self.triggerMethod('modal:hidden', self, options);
          }
        });
    }

  };

  module.exports = SidebarMixin;
});

